import { Box } from '@apia/theme';
import { observer } from 'mobx-react-lite';
import { ReactNode } from 'react';

export const Header = observer(
  ({ childComponent }: { childComponent: ReactNode }) => {
    return <Box className="search_header_container">{childComponent}</Box>;
  },
);
